import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import * as L from "leaflet";
import { Router } from "@angular/router";
import { ApiService } from "src/app/providers/api.service";
import { animate } from "@angular/animations";
import { Location, DatePipe } from "@angular/common";
import { NzMessageService } from "ng-zorro-antd/message";
import { FormGroup, FormControl, Validator, Validators } from "@angular/forms";
import moment from "moment";
import "leaflet.heat/dist/leaflet-heat.js";
import { differenceInCalendarDays, startOfDay } from "date-fns";

@Component({
  selector: "app-heatmap",
  templateUrl: "./heatmap.component.html",
  styleUrls: ["./heatmap.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HeatmapComponent implements OnInit, OnDestroy {
  isCollapsed = false;
  opnSdebar: boolean;
  heatform: any;
  assrtGroupList: any = [];
  asrtctry: any = [];
  heatmap;
  date = new Date();
  sdate: Date = new Date();
  edate: Date = new Date();
  strtTm = this.datepipe.transform(this.date, "yyyy-MM-dd");
  endTm = this.datepipe.transform(this.date, "yyyy-MM-dd");
  heatmapLayer: any;
  asrtGrps: any = [];
  asrtctgrs: any = [];
  asrtCtgryList: any = [];
  asrt_grp_id;
  asrt_ctgry_id;
  clntDtls: any = [];
  tntLst: any = [];
  selectedtenants: any;
  weeklyHeatMapData: any = [];
  vehicleData: any;
  tdata: any;
  testData: any = [];
  showAll: boolean = false;
  slctdDfltTnt: any;
  usrDtls: any;
  clap_in: any;
  title;
  ShowClap: boolean;
  _tntBndLyr;
  tntPlygons;
  dateTime: any = [];
  today = new Date();

  // New properties for redesigned UI
  vehiclesList: any[] = [];
  selectedVehicle: any;
  visibleVhclSldr: boolean = false;
  filterPanelOpen: boolean = true;
  showLdr: boolean = false;
  heatDataLoading: boolean = false; // Preserved property if needed elsewhere

  // Category chips with counts (like ams-vehicles)
  ctgryCardcntSummary: any[] = [];
  activeCategoryKey: number = 0;
  slctdDt = new Date();
  asrt_ctgry_nm;
  constructor(
    private apiS: ApiService,
    private router: Router,
    private ref: ChangeDetectorRef,
    public datepipe: DatePipe,
    private message: NzMessageService
  ) {
    this.heatform = new FormGroup({
      ulbs: new FormControl(""),
      lctn: new FormControl(""),
      vhcl: new FormControl(""),
      strtTm: new FormControl(""),
      endTm: new FormControl(""),
      dtrng: new FormControl(""),
    });
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    console.log(this.clntDtls);
    this.tntLst = this.clntDtls[0].tnts;
    if (this.tntLst.length <= 8 && this.tntLst.length > 1) {
      this.title = "ULB";
    } else {
      this.title = "ULB";
    }
    if (this.tntLst.length == 1) {
      this.selectedtenants = this.tntLst[0].tnt_id;
      this.slctdDfltTnt = this.selectedtenants;
      console.log(this.selectedtenants);
      this.showAll = false;
    } else {
      this.selectedtenants = 0;
      this.slctdDfltTnt = this.selectedtenants;
      console.log(this.selectedtenants);
      this.showAll = true;
    }
    this.usrDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    this.clap_in = this.usrDtls.clap_in;
    if (this.clap_in == 1) {
      this.ShowClap = true;
    }
  }

  ngOnInit(): void {
    this.initialize();
    this.opnSdebar = true;
  }
  closeSidebar() {
    this.isCollapsed = true;
    this.opnSdebar = false;
  }
  openSidebar() {
    this.isCollapsed = false;
    this.opnSdebar = true;
  }
  initialize = function () {
    this.usrDtls = JSON.parse(localStorage.getItem("wto_clients"));
    console.log(this.usrDtls);
    //----------Map Initialization (Default openstreetmap  Layer) -- Leaflet OS Playback----------//
    try {
      this.heatmap = L.map("heatmap", {
        doubleClickZoom: false,
        maxZoom: 18,
        minZoom: 7,
        zoomControl: false, // Disable default zoom control
      });

      // Add zoom control at bottom-left position (under filters)
      L.control
        .zoom({
          position: "bottomleft",
        })
        .addTo(this.heatmap);

      L.tileLayer("http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}", {
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
        attribution: "",
      }).addTo(this.heatmap);
    } catch (e) {
      console.log("please check map Initialization of leaflet:" + e);
    }
    if (this.slctdDfltTnt) {
      this.ontntSelects(this.slctdDfltTnt);
    }
    this._tntBndLyr = L.layerGroup();
  };

  disabledDate = (current: Date): boolean => {
    const today = startOfDay(new Date());
    // Disable only past dates, allow today and future dates
    return !!current && differenceInCalendarDays(current, today) > 0;
  };
  onChange(result: Date[]): void {
    console.log(this.datepipe.transform(result[0], "yyyy-MM-dd"));
    let strtDt = moment(this.dateTime[0]).format("YYYY-MM-DD");
    let endDt = moment(this.dateTime[1]).format("YYYY-MM-DD");
    console.log(strtDt, endDt);
    this.heatform.get("strtTm").setValue(strtDt);
    this.heatform.get("endTm").setValue(endDt);
  }

  generatemap() {
    var data = {
      sdate: this.heatform.value.strtTm,
      edate: this.heatform.value.endTm,
      asrt_grp_id: this.asrtGrps,
      asrt_ctgry_id: this.asrtctry,
      selectedtenant: this.selectedtenants,
    };
    console.log(data);
    this.genHeatMapLayer(data);
  }

  genHeatMapLayer(data) {
    this.vehicleData = [];
    this.showLdr = true; // Show loader

    if (this.heatmapLayer) {
      this.heatmap.removeLayer(this.heatmapLayer);
    }

    this.apiS.post(data, "playback/dashboard/heatMap").subscribe(
      (res) => {
        this.weeklyHeatMapData = res["data"];
        console.log(this.weeklyHeatMapData, "this.weeklyHeatMapData");

        // Check if data exists
        if (!this.weeklyHeatMapData || this.weeklyHeatMapData.length === 0) {
          this.showLdr = false;
          this.message.info("No heatmap data found for the selected criteria");
          return;
        }

        // Convert to proper format for L.heatLayer: [lat, lng, intensity]
        for (var i = 0; i < this.weeklyHeatMapData.length; i++) {
          if (this.weeklyHeatMapData[i].lat && this.weeklyHeatMapData[i].lng) {
            // Use array format [lat, lng, intensity] for better compatibility
            this.vehicleData.push([
              this.weeklyHeatMapData[i].lat,
              this.weeklyHeatMapData[i].lng,
              1, // intensity
            ]);
          }
        }

        console.log(this.vehicleData, "this.vehicleData");

        // Only create heatmap if we have valid data points
        if (this.vehicleData.length > 0) {
          // Adjust radius based on number of points - larger radius for fewer points
          const dynamicRadius =
            this.vehicleData.length === 1
              ? 25
              : this.vehicleData.length < 10
              ? 18
              : 12;

          this.heatmapLayer = L.heatLayer(this.vehicleData, {
            maxZoom: 15,
            minZoom: 8,
            radius: dynamicRadius,
            maxOpacity: 0.8,
          }).addTo(this.heatmap);

          // If single point, zoom to that location
          if (this.vehicleData.length === 1) {
            this.heatmap.setView(
              [this.vehicleData[0][0], this.vehicleData[0][1]],
              14
            );
          }
        } else {
          this.message.info("No valid coordinates found in heatmap data");
        }

        this.showLdr = false; // Hide loader
      },
      (err) => {
        console.log("In errorr");
        this.showLdr = false; // Hide loader on error
        this.message.error("Failed to load heatmap data");
      }
    );
  }

  ontntSelects(value) {
    console.log(value);
    this.selectedtenants = value;
    if (value == 0) {
      this.heatmap.setView([this.clntDtls[0].lat, this.clntDtls[0].lng], 8);
      this.heatmap.setMinZoom(7);
    } else {
      for (var i = 0; i < this.tntLst.length; i++) {
        if (this.tntLst[i].tnt_id == this.selectedtenants) {
          this.heatmap.setView([this.tntLst[i].lat, this.tntLst[i].lng], 13);
          this.heatmap.setMinZoom(9);
          this.plotTntBounds();
        }
      }
    }
    this.showLdr = true;
    this.apiS.get(`playback/vehicle/groups/${this.selectedtenants}`).subscribe(
      (res) => {
        this.showLdr = false;
        if (res["status"] == 200) {
          this.assrtGroupList = res["data"];
          console.log(this.assrtGroupList);
        }
      },
      (err) => {
        this.showLdr = false;
        console.log("In errorr");
      }
    );

    // Fetch category summary with counts
    this.getCategorySummary();
  }

  // Get category summary with vehicle counts
  getCategorySummary() {
    this.showLdr = true;
    this.apiS
      .get(`drivers/vehicle-wise/ctgry/summary/0/${this.selectedtenants}`)
      .subscribe(
        (res) => {
          this.showLdr = false;
          if (res["status"] == 200) {
            this.ctgryCardcntSummary = res["data"];
            console.log("Category Summary:", this.ctgryCardcntSummary);
          }
        },
        (err) => {
          this.showLdr = false;
          console.log("Error fetching category summary:", err);
        }
      );
  }
  getCatLists(grpId) {
    // console.log("gettttttttttttttttttttttttttttt");
    console.log(grpId);

    this.asrt_grp_id = grpId;
    this.asrtGrps = grpId;
    this.asrtCtgryList = [];
    this.asrt_ctgry_id = 0;
    console.log(this.asrtGrps);
    console.log(grpId);

    if (this.asrtGrps == "select") {
      this.asrtGrps = 0;
      this.asrt_grp_id = 0;
      var asrt_data = {
        asrt_grp: this.asrtGrps,
      };
      // console.log(asrt_data);
      this.showLdr = true;
      this.apiS.post(asrt_data, "playback/categories/assets").subscribe(
        (res) => {
          this.showLdr = false;
          this.asrtCtgryList = res["data"];
          console.log(this.asrtCtgryList);
        },
        (err) => {
          this.showLdr = false;
          console.log("In errorr");
        }
      );
    } else if (this.asrtGrps == "deselect") {
      this.asrtGrps = [];
      return;
    } else if (this.clap_in == 1) {
      var asrt_data = {
        asrt_grp: this.asrtGrps,
      };
      // console.log(asrt_data);
      this.showLdr = true;
      this.apiS.post(asrt_data, "playback/categories/assets").subscribe(
        (res) => {
          this.showLdr = false;
          this.asrtCtgryList = res["data"];
          console.log(this.asrtCtgryList);
        },
        (err) => {
          this.showLdr = false;
          console.log("In errorr");
        }
      );
      return;
    } else {
      var asrt_data = {
        asrt_grp: this.asrtGrps,
      };
      // console.log(asrt_data);
      this.showLdr = true;
      this.apiS.post(asrt_data, "playback/categories/assets").subscribe(
        (res) => {
          this.showLdr = false;
          this.asrtCtgryList = res["data"];
          console.log(this.asrtCtgryList);
        },
        (err) => {
          this.showLdr = false;
          console.log("In errorr");
        }
      );
    }
  }
  // getTypeList(catId) {
  //   this.asrt_ctgry_id = catId;
  //   this.asrtctgrs = catId;

  //   if (this.asrtctgrs == 'select') {
  //     this.asrtctgrs = 0;
  //     this.asrt_ctgry_id = 0;
  //   }

  // };
  closedrvrlst() {
    this.opnSdebar = false;
  }
  plotTntBounds() {
    if (this._tntBndLyr != undefined) {
      this._tntBndLyr.clearLayers();
    }
    setTimeout(() => {
      for (var i = 0; i < this.tntLst.length; i++) {
        if (this.tntLst[i].tnt_id == this.selectedtenants) {
          this.heatmap.setView([this.tntLst[i].lat, this.tntLst[i].lng], 13);
          if (this.tntLst[i].bndry_jsn != null) {
            // console.log(this.tntLst[i].bndry_jsn)
            this.tntPlygons = L.polygon(JSON.parse(this.tntLst[i].bndry_jsn), {
              color: "#f1cee0",
              fill: false,
              // weight: 1,
            }).addTo(this._tntBndLyr);
            this._tntBndLyr.addTo(this.heatmap);
          }
        }
      }
    }, 2000);
  }

  // Toggle filter panel visibility and invalidate map size
  toggleFilterPanel() {
    this.filterPanelOpen = !this.filterPanelOpen;
    // Invalidate map size after animation completes
    setTimeout(() => {
      if (this.heatmap) {
        this.heatmap.invalidateSize();
      }
    }, 350);
  }

  // Handle category chip selection
  onCategoryChipSelect(chip: any) {
    const categoryId = chip.asrt_ctgry_id || 0;
    this.activeCategoryKey = categoryId;
    this.asrtctry = categoryId;

    if (categoryId && categoryId !== 0) {
      this.getVehiclesByCategory(categoryId);
    } else {
      this.vehiclesList = [];
    }
  }

  // Check if category chip is active
  isCategoryActive(chip: any): boolean {
    const chipId = chip.asrt_ctgry_id || 0;
    return chipId === this.activeCategoryKey;
  }

  // Handle category selection and fetch vehicles
  onCategorySelect(categoryId: any) {
    this.asrtctry = categoryId;
    if (categoryId && categoryId !== 0) {
      this.asrtCtgryList.forEach((element) => {
        if (element.asrt_ctgry_id == categoryId) {
          this.asrt_ctgry_nm = element.asrt_ctgry_nm;
        }
      });
    } else {
      this.asrt_ctgry_nm = "All Vehicles";
    }
    this.activeCategoryKey = categoryId || 0;
    // Load vehicles for all categories including "All"
    this.getVehiclesByCategory(categoryId || 0);
  }

  // Fetch vehicles by category
  getVehiclesByCategory(categoryId: any) {
    this.showLdr = true;
    const data = {
      selectedtenant: this.selectedtenants || 0,
      selectedctgry: categoryId,
      selectedvndr: 0,
    };

    this.apiS.post(data, "drivers/vehicles/vehicles").subscribe(
      (res: any) => {
        this.showLdr = false;
        if (res.status === 200 && res.data) {
          this.vehiclesList = res.data;
          // Process vehicle icon paths
          this.vehiclesList.forEach((v) => {
            if (v.asrtglblId === 1) {
              v.icon_pathr = v.icon_path + (v.spd_ct > 0 ? "_r" : "_p");
            } else {
              v.icon_pathr = v.icon_path + "_o";
            }
          });
          console.log("Vehicles loaded:", this.vehiclesList);
        } else {
          this.vehiclesList = [];
          this.message.info("No vehicles found for this category");
        }
      },
      (err) => {
        this.showLdr = false;
        console.log("Error fetching vehicles:", err);
        this.message.error("Failed to load vehicles");
        this.vehiclesList = [];
      }
    );
  }

  // Open vehicle slider
  openVehicleSlider(vehicle: any) {
    this.selectedVehicle = vehicle;
    this.visibleVhclSldr = true;
  }

  // Clear vehicles list
  clearVehiclesList() {
    this.vehiclesList = [];
    this.asrtctry = null;
  }

  ngOnDestroy(): void {
    // Remove heatmap layer
    if (this.heatmapLayer && this.heatmap) {
      try {
        this.heatmap.removeLayer(this.heatmapLayer);
      } catch (e) {}
      this.heatmapLayer = null;
    }

    // Remove tenant boundary layer
    if (this._tntBndLyr) {
      try {
        this._tntBndLyr.clearLayers();
        if (this.heatmap) {
          this.heatmap.removeLayer(this._tntBndLyr);
        }
      } catch (e) {}
      this._tntBndLyr = null;
    }

    // Destroy map instance
    if (this.heatmap) {
      try {
        this.heatmap.off();
        this.heatmap.eachLayer((layer) => {
          try {
            this.heatmap.removeLayer(layer);
          } catch (e) {}
        });
        this.heatmap.remove();
      } catch (e) {}
      this.heatmap = null;
    }

    // Clear data arrays
    this.weeklyHeatMapData = [];
    this.vehicleData = [];
    this.vehiclesList = [];
    this.assrtGroupList = [];
    this.asrtCtgryList = [];
    this.ctgryCardcntSummary = [];
  }
}
